import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import ButtonMenu from "../../components/buttons/ButtonMenu";
import { useNavigate, useParams } from "react-router-dom";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import { PRODUCT } from "../../Admin/AdminPanelOperations";
import { useState } from "react";
import { useEffect } from "react";
import { deleteProductHttp } from "../../services/ProductService";
import { useDataProvider } from "../../context/DataContext";
import Categories from "../../Categories";
import BackdropLoading from "../display/BackdropLoading";
import { useAuth } from "../../hooks/useAuth";

const CategoryDetails = () => {
  let { catIndex } = useParams();
  const { data } = useDataProvider();
  const navigate = useNavigate();
  const { isAdmin } = useAuth();
  const [category, setCategory] = useState();

  const filterItems = (categoryIndex) => {
    const newItems = data[categoryIndex];
    setCategory(newItems);
  };

  useEffect(() => {
    filterItems(catIndex);
  }, [data, catIndex]);

  const renderProductItem = (product) => {
    const { id, name, thumbnailPhoto, description, price } = product;

    const handleUpdateProduct = (id) => {
      navigate(`/admin-panel/update/${PRODUCT}/${id}`);
    };

    const handleDeleteProduct = (id) => {
      deleteProductHttp(id).finally(() => window.location.reload());
    };

    return (
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6} padding={1}>
        <article key={id} className="menu-item">
          <Box position="relative">
            {isAdmin && (
              <ButtonMenu
                actions={[
                  {
                    icon: <EditIcon />,
                    name: "update",
                    onClick: () => handleUpdateProduct(id),
                  },
                  {
                    icon: <DeleteForeverIcon />,
                    name: "delete",
                    onClick: () => handleDeleteProduct(id),
                  },
                ]}
              />
            )}
            <img
              src={thumbnailPhoto || "/images/brand.png"}
              style={{ objectFit: !thumbnailPhoto && "contain" }}
              alt={name}
              className="photo"
            />
          </Box>
          <div className="item-info">
            <header>
              <h4>{name}</h4>
              <h4 className="price">{price} ₺</h4>
            </header>
            <p className="item-text">{description}</p>
          </div>
        </article>
      </Grid>
    );
  };
  
  return (data.length > 0 && category) ? (
    <Grid container mt={0}>
      {/* <pre style={{maxHeight: 200}}>{JSON.stringify(category,null,2)}</pre> */}
        <Categories />
        <Grid item lg={12} sm={12} md={12} xs={12}>
          <h3 style={{ marginBottom: "0.35rem", marginTop: "0.35rem", textAlign: "center" }}>{category.categoryName}</h3>
        </Grid>
        {category.subcategories !== undefined && category.subcategories.length < 1 && category.products !== undefined && category.products.length < 1 &&
          <Grid item lg={12} sm={12} md={12} xs={12} height={500} display="flex" justifyContent="center" alignItems="center" >
            <Typography variant="h5" textAlign="center" fontFamily="'Poppins', sans-serif">
              Bu kategoride ürün bulunmamaktadır.
            </Typography>
          </Grid>
        }
        {category !== undefined && category.products.length > 0 && category.products.map((product) => {
          return renderProductItem(product);
        })}
        {category !== undefined && category.subcategories.length > 0 && category.subcategories.map((subcategory, index) => {
          return (
            <>
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                borderBottom={1}
                mt={(index !== 0 || category.products.length > 0) && 3}
                marginX={1}
                key={index}
              >
                <h4 style={{ marginBottom: "0.35rem" }}>{subcategory.name}</h4>
              </Grid>
              {subcategory.products.map((product, index) => {
                return renderProductItem(product);
              })}
            </>
          );
        })}
      </Grid>
  ) : (
    <BackdropLoading loading={true} />
  );
};

export default CategoryDetails;
